import { SummonerChampionStats } from "@ugg/shared/components/SummonerProfiles/champion-stats/SummonerChampionStats";

export function SummonerProfileChampionStatsPage() {
  return (
    <div className="w-[1016px] max-md:w-full">
      <SummonerChampionStats />
    </div>
  );
}
